import { render, staticRenderFns } from "./MobAdCard.vue?vue&type=template&id=bde2fe80"
import script from "./MobAdCard.vue?vue&type=script&scoped=true&lang=js"
export * from "./MobAdCard.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./MobAdCard.vue?vue&type=style&index=0&id=bde2fe80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports